import Issuer from './issuer ';
import PayerCost from './payer-cost';

export default class InstallmentResponse {
  public payment_method_id?: string;
  public payment_type_id?: string;
  public processing_mode?: string;
  public merchant_account_id?: string | null;
  public agreements?: any | null;
  public issuer?: Issuer;
  public payer_costs?: PayerCost[];
}
